import getCurrentPackageFeatureLimits from './get-current-package-feature-limits';
import getFeatureLimits from './get-feature-limits';

export default {
  getCurrentPackageFeatureLimits,
  getFeatureLimits,
};
